import React from "react";
import { differenceInYears } from "date-fns";

import { DataElement } from "affinityUI/data/dataElement";
import { List } from "affinityUI/data/list";
import { DateTime } from "affinityUI/data/valueDisplay";
import { Grid } from "affinityUI/elements/grid";
import { Highlight } from "affinityUI/elements/highlight";
import { PatientsListEntry } from "types/patient";

export type PatientCardProps = {
  patient: PatientsListEntry;
  searchTerm?: Maybe<string>;
};

export const PatientCard: React.FC<PatientCardProps> = ({ searchTerm, patient, ...rest }) => {
  const age = differenceInYears(new Date(), new Date(patient.dateOfBirth));
  const href = `/patients/${patient.id}`;
  const name = <Highlight searchTerm={searchTerm} text={`${patient.lastName}, ${patient.firstName}`} />;
  return (
    <List.Item
      data-testid="patient-card"
      key={patient.id}
      aria-label={`View ${patient.lastName}, ${patient.firstName}`}
      linkTo={href}
      {...rest}
    >
      <Grid $cols={Grid.cols.EQUAL}>
        <DataElement label={name as unknown as string}>{patient.sex}</DataElement>
        <DataElement label="DOB:">
          <DateTime format={DateTime.FORMAT.DATE} value={patient.dateOfBirth} /> ({age})
        </DataElement>
        <DataElement label="HOSP. no:">
          <Highlight searchTerm={searchTerm} text={patient.hospitalNumber} />
        </DataElement>
        <DataElement label="NHS no:">
          <Highlight searchTerm={searchTerm} text={patient.nhsNumber} />
        </DataElement>
        <DataElement label="Patient ID:">
          <Highlight searchTerm={searchTerm} text={patient.id} />
        </DataElement>
      </Grid>
    </List.Item>
  );
};
